import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-lg"
};
const _hoisted_2 = {
  class: "flex items-center"
};
const _hoisted_3 = {
  class: "mr-1"
};
const _hoisted_4 = {
  class: "font-bold text-red-600"
};
const _hoisted_5 = {
  class: "flex items-center"
};
const _hoisted_6 = {
  class: "mr-1"
};
const _hoisted_7 = {
  class: "font-bold text-green-600"
};
const _hoisted_8 = {
  class: "flex-center"
};
import { Team } from "@/modules/team/entity";
import { app } from "@/di";
import GateManager from "@/modules/action-points/services/GateManager";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { EventEmitter } from "@/modules/base/events";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
import CoinsCurrencyExchanger from "@/modules/action-points/services/CoinsCurrencyExchanger";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
import Icon from "@/modules/vue/components/Icon.vue";
import { generateColorMap } from "@/modules/vue/utils";
import { ColorEnum, IconEnum } from "@/modules/vue/enums";
import Stepper from "@/modules/vue/components/Stepper.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Exchange',
  props: {
    type: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const targetCurrency = ref(props.type ?? GateTypeEnum.NEGOTIATION);
    const currencies = ref([{
      label: translator.t(`action_points_negotiation`),
      value: GateTypeEnum.NEGOTIATION,
      icon: IconEnum.Handshake20Regular,
      color: ColorEnum.Fuchsia
    }, {
      label: translator.t(`action_points_scouting`),
      value: GateTypeEnum.SCOUTING,
      icon: IconEnum.Binoculars,
      color: ColorEnum.Sky
    }, {
      label: translator.t(`action_points_training_gk`),
      value: GateTypeEnum.TRAINING_GK,
      icon: IconEnum.Dumbbell,
      color: ColorEnum.Red
    }, {
      label: translator.t(`action_points_training_df`),
      value: GateTypeEnum.TRAINING_DF,
      icon: IconEnum.Dumbbell,
      color: ColorEnum.Red
    }, {
      label: translator.t(`action_points_training_mf`),
      value: GateTypeEnum.TRAINING_MF,
      icon: IconEnum.Dumbbell,
      color: ColorEnum.Red
    }, {
      label: translator.t(`action_points_training_at`),
      value: GateTypeEnum.TRAINING_AT,
      icon: IconEnum.Dumbbell,
      color: ColorEnum.Red
    }]);
    const colorMap = generateColorMap({
      text: 500
    });
    const renderCurrencyLabel = option => {
      return h(
      // @ts-ignore
      'div', {
        class: `leading-none h-full flex items-center ${colorMap[option.color]}`
      }, [h(Icon, {
        class: 'mr-2',
        icon: option.icon
      }), option.label]);
    };
    const coinsGate = ref(app.get(GateManager).getGate(GateTypeEnum.COINS));
    const team = ref();
    const currentCoins = ref();
    const balance = ref();
    const exchange = ref(0);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
      if (team.value && targetCurrency.value) {
        currentCoins.value = await coinsGate.value.currency.get();
        balance.value = await app.get(GateManager).getGate(targetCurrency.value).currency.get();
      }
    })), __temp = await __temp, __restore(), __temp);
    const gainBalance = computed(() => exchange.value * 100);
    onBeforeUnmount(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    const message = useMessage();
    const onExchange = async () => {
      await app.get(CoinsCurrencyExchanger).exchange(team.value, exchange.value, targetCurrency.value);
      exchange.value = 0;
      message.success(translator.t('done'));
    };
    return (_ctx, _cache) => {
      const _component_NSelect = _resolveComponent("NSelect");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(FormGroup, {
        label: _ctx.$t('currency')
      }, {
        default: _withCtx(() => [_createVNode(_component_NSelect, {
          value: targetCurrency.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => targetCurrency.value = $event),
          options: currencies.value,
          "render-label": renderCurrencyLabel
        }, null, 8, ["value", "options"])]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('coins')
      }, {
        default: _withCtx(() => [_createVNode(Stepper, {
          modelValue: exchange.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => exchange.value = $event),
          min: 0,
          max: currentCoins.value
        }, null, 8, ["modelValue", "max"])]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        label: _ctx.$t('coins')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(currentCoins.value), 1), _createElementVNode("span", _hoisted_4, "- " + _toDisplayString(_ctx.$n(exchange.value)), 1)])]),
        _: 1
      }, 8, ["label"]), _createVNode(FormGroup, {
        class: "mb-8"
      }, {
        label: _withCtx(() => [_createTextVNode(_toDisplayString(targetCurrency.value), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(Math.floor(balance.value)), 1), _createElementVNode("span", _hoisted_7, "+ " + _toDisplayString(_ctx.$n(_unref(gainBalance))), 1)])]),
        _: 1
      }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_NButton, {
        disabled: exchange.value < 1,
        secondary: "",
        type: "success",
        size: "large",
        onClick: onExchange
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _unref(IconEnum).ArrowsHorizontal,
          class: "mr-2"
        }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('exchange')), 1)]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});